import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=0aa78bcf&v-on-clickaway=cancel&"
import script from "./EditProfile.vue?vue&type=script&lang=ts&"
export * from "./EditProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports